module.exports = __webpack_public_path__ + "assets/img/00041.16f673a4.png";